import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { IRole } from '@models/Interface/IRole';
import type { IResponsibilitiesResponse } from '@models/Interface/rolesResponsibilities.types';

export class RolesService {
    static async fetchResponsibilities(signal?: AbortSignal): Promise<AxiosResponse<IResponsibilitiesResponse>> {
        return $api.get<IResponsibilitiesResponse>('/AccessGroups/responsibilities', { signal });
    }

    static async fetch(): Promise<AxiosResponse<IRole[]>> {
        return $api.get<IRole[]>('/AccessGroups');
    }
}
